import { enqueueSnackbar } from "notistack";
import { create } from "zustand";

import { whitelabelRepository } from "src/repositories/whitelabel/whitelabel.repository";
import { Whitelabel, WhitelabelState } from "src/types/whitelabel";

type Actions = {
  setLoading: (loading: boolean) => void;
  fetchWhitelabel: (host: string) => Promise<void>;
};

const initialValues: WhitelabelState = {
  whitelabel: null,
  loading: true,
  error: null,
};

export const useWhitelabelStore = create<WhitelabelState & Actions>((set) => ({
  ...initialValues,

  setLoading: (loading: boolean) => set({ loading }),

  fetchWhitelabel: async (host: string) => {
    set({ loading: true, error: null });
    try {
      const whitelabel: Whitelabel =
        await whitelabelRepository.getByShoppingId(host);
      set({ whitelabel, loading: false });
    } catch (error: any) {
      enqueueSnackbar("Erro ao buscar informações de whitelabel", {
        variant: "error",
      });
      set({ loading: false, error: error.message, whitelabel: null });
    }
  },
}));
